import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import styled from 'styled-components';
import { BrokerJob } from '../../core';
import { resolveServiceIcon } from '../serviceIcon';

const Wrapper = styled('div')(({ theme }) => ({
	alignItems: 'center',
	display: 'flex',
	gap: theme.spacing(1),
	minWidth: 0,
}));

const ServiceName = styled('span')({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

export function ServiceCell({ row }: GridRenderCellParams<BrokerJob, string>) {
	const ServiceIcon = resolveServiceIcon(row.serviceIcon);

	return (
		<Wrapper>
			<ServiceIcon fontSize="small" sx={{ color: 'text.secondary' }} />
			<ServiceName>{row.serviceName}</ServiceName>
		</Wrapper>
	);
}
